export type DocumentCategory = "clientwise" | "vehiclewise";

const CLIENTWISE_KEYWORDS = [
  "fssai",
  "shop",
  "establishment",
  "trade",
  "clra",
  "repacker",
];

const VEHICLEWISE_KEYWORDS = [
  "insurance",
  "permit",
  "driving",
  "pollution",
  "fitness",
  "registration",
  "road_tax",
  "road tax",
  "roadtax",
];

export const getDocumentCategory = (
  documentType?: string
): DocumentCategory | null => {
  if (!documentType) return null;
  const t = documentType.toLowerCase();
  if (VEHICLEWISE_KEYWORDS.some((k) => t.includes(k))) return "vehiclewise";
  if (CLIENTWISE_KEYWORDS.some((k) => t.includes(k))) return "clientwise";
  return null;
};

export const matchesCategory = (
  documentType: string | undefined,
  category: DocumentCategory
): boolean => getDocumentCategory(documentType) === category;

export const CATEGORY_LABEL: Record<DocumentCategory, string> = {
  clientwise: "Clientwise",
  vehiclewise: "Vehiclewise",
};
